module.exports = __webpack_public_path__ + "img/1479571674.a8843367.jpg";